import { heroLead, heroSecondary } from "@/mocks/home";
import Reveal from "@/components/base/Reveal";

export default function HeroSection() {
  return (
    <section id="top" className="bg-background-50">
      <div className="mx-auto max-w-[1400px] px-4 pb-10 pt-8 md:px-8 md:pb-14 md:pt-12">
        <Reveal>
          <div className="mb-6 flex flex-wrap items-end justify-between gap-4 md:mb-8">
            <div>
              <span className="inline-flex items-center gap-2 text-xs text-primary-600">
                <span className="h-1.5 w-1.5 rounded-full bg-primary-500" />
                今日焦点 · 多线索并列
              </span>
              <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-4xl">
                头条与连线
              </h2>
            </div>
            <p className="max-w-md text-sm leading-relaxed text-foreground-600">
              进展、证据、通报与后续瓜分栏并列呈现，一眼看清事件全貌，再决定追踪哪一条线索。
            </p>
          </div>
        </Reveal>

        <div className="grid grid-cols-1 gap-4 md:gap-6 lg:grid-cols-12">
          <Reveal className="lg:col-span-7">
            <article className="group flex h-full flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 sm:flex-row">
              <div className="relative h-52 w-full shrink-0 sm:h-auto sm:w-[46%]">
                <img
                  src={heroLead.image}
                  alt={heroLead.title}
                  title={`${heroLead.title} 网曝黑料 最新进展`}
                  className="h-full w-full object-cover object-top"
                />
                <span className="absolute left-3 top-3 rounded-md bg-primary-500 px-2.5 py-1 text-[11px] font-medium text-background-50">
                  {heroLead.tag}
                </span>
              </div>
              <div className="flex flex-1 flex-col p-5 md:p-6">
                <div className="flex flex-wrap items-center gap-3 text-xs text-foreground-500">
                  <span className="flex items-center gap-1">
                    <i className="ri-fire-line text-primary-500" />
                    热度 {heroLead.heat}
                  </span>
                  <span className="h-3 w-px bg-background-300" />
                  <span>{heroLead.source}</span>
                  <span className="h-3 w-px bg-background-300" />
                  <span>{heroLead.time}</span>
                </div>
                <h3 className="mt-4 font-heading text-xl font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-600 md:text-2xl">
                  {heroLead.title}
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-foreground-600">
                  {heroLead.summary}
                </p>
                <div className="mt-auto flex items-center justify-between pt-5">
                  <span className="flex items-center gap-1 text-xs text-foreground-500">
                    <span className="h-2 w-2 animate-pulse rounded-full bg-accent-500" />
                    线索仍在更新
                  </span>
                  <span className="flex items-center gap-1 text-sm font-medium text-primary-600">
                    查看全部进展
                    <i className="ri-arrow-right-s-line" />
                  </span>
                </div>
              </div>
            </article>
          </Reveal>

          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 md:gap-6 lg:col-span-5">
            {heroSecondary.map((item, index) => (
              <Reveal key={item.title} delay={index * 80}>
                <article className="group flex h-full flex-col rounded-lg border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-300 md:p-5">
                  <div className="flex flex-wrap items-center gap-2">
                    <span className="rounded-full bg-secondary-100 px-2 py-0.5 text-[11px] text-secondary-900">
                      {item.tag}
                    </span>
                    <span className="text-[11px] text-foreground-500">{item.time}</span>
                  </div>
                  <h3 className="mt-3 font-heading text-base font-semibold leading-snug text-foreground-950 transition-colors group-hover:text-primary-600 md:text-lg">
                    {item.title}
                  </h3>
                  <p className="mt-2 text-xs leading-relaxed text-foreground-600 md:text-sm">
                    {item.summary}
                  </p>
                  <div className="mt-auto flex items-center justify-between pt-3 text-[11px] text-foreground-500">
                    <span className="flex items-center gap-1">
                      <i className="ri-fire-line text-primary-500" />
                      {item.heat}
                    </span>
                    <span className="flex items-center gap-1 text-primary-600 opacity-0 transition-opacity group-hover:opacity-100">
                      详情
                      <i className="ri-arrow-right-s-line" />
                    </span>
                  </div>
                </article>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}